/**
 * Auth API calls for the web panel (D-06).
 *
 * Login sends surface:'web' so the backend sets httpOnly cookies instead
 * of returning bearer tokens in the response body. The response body for
 * web surface has empty accessToken/refreshToken and only expiresIn.
 *
 * checkSession attempts POST /v1/auth/refresh with the existing cookie
 * to verify the session is still valid. If the cookie is valid, the
 * backend refreshes the access cookie transparently.
 */
import { api } from './client';

export interface LoginApiResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export async function loginApi(
  email: string,
  password: string,
): Promise<LoginApiResponse> {
  return api
    .post('auth/login', {
      json: { email, password, surface: 'web' },
    })
    .json<LoginApiResponse>();
}

export async function logoutApi(): Promise<void> {
  await api.post('auth/logout').catch(() => {
    // Best-effort logout -- clear local state regardless
  });
}

/**
 * Verify that existing cookies are still valid by attempting a refresh.
 * Returns true if the session is active, false otherwise.
 */
export interface MeResponse {
  userId: string;
  email: string;
  name: string;
  organizationId: string;
  organizationName: string;
  role: string;
}

export async function fetchMe(): Promise<MeResponse> {
  return api.get('auth/me').json<MeResponse>();
}

export async function checkSession(): Promise<boolean> {
  try {
    const res = await fetch('/v1/auth/refresh', {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({}),
    });
    return res.ok;
  } catch {
    return false;
  }
}
